module.exports = __webpack_public_path__ + "img/oral_counting_2.2ccb9976.png";